import React, { Component } from 'react'
import Ad from '../Ad'
import PropTypes from 'prop-types'
import styles from './ContactsPage.module.scss'

class ContactsPage extends Component {
  render() {
    const {
      node: { frontmatter, html },
    } = this.props.data
    return (
      <div className={styles.root}>
        <h1 className={styles.title}>{frontmatter.title}</h1>
        <img
          className={styles.promoPicture}
          src={'https://ucarecdn.com/1490978a-fd8a-40f7-b9bc-6f91b3549fd4/-/progressive/yes/-/quality/lightest/'}
          alt=""
        />
        <div className={styles.inner}>
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: html }} />
          <div className={styles.ad}>
            <Ad locale={this.props.locale} />
          </div>
        </div>
      </div>
    )
  }
}

ContactsPage.propTypes = {
  frontmatter: PropTypes.shape({
    title: PropTypes.string,
  }),
  html: PropTypes.string,
}

export default ContactsPage
